module.exports = __webpack_public_path__ + "static/media/SNOB-AVAX.0f30e70b.svg";